export const MAX_TAG_ELEMENTS = 16;
export const MAX_TAG_LENGTH = 64;
export const MAX_NAME_LENGTH = 64;
export const MAX_DESCRIPTION_LENGTH = 256;
//# sourceMappingURL=upsert-validation-constants.js.map